export default __webpack_public_path__ + "static/media/5141.6df1cd64.png";